import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { InitiatedByPersonNameItem, TypeaheadService } from '../../../services/typeahead.service';

@Component({
  selector: 'tt-custact-member-edit',
  templateUrl: './custact-member-edit.component.html',
  styleUrls: ['./custact-member-edit.component.css']
})
export class CustactMemberEditComponent implements OnInit {
    custactNo;

    public custactMemberKeyno: string;

    public personButtons: FormButton[] = [
        {
            id: 'goto',
            type: 'primary',
            icon: 'fas fa-chevron-right',
            goto: 'person',
            gotoParms: () => ({
                cust_no: this.edit!.cust_no,
                pers_no: this.edit!.pers_no
            })
        }
    ];

    public customerNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'customersmenu', gotoParms: () => this.edit!.cust_no ?? '' }];

    public edit?: Edit;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private typeahead: TypeaheadService) {
        this.custactNo = this.stateService.getStateParams()['custact_no'];
        this.custactMemberKeyno = this.stateService.getStateParams()['custact_member_keyno'];
    }

    private async loadEdit() {
        if (!!this.custactNo && !!this.custactMemberKeyno) {
            this.edit = (await this.datatask.Post(93, {
                custact_no: this.custactNo,
                custact_member_keyno: this.custactMemberKeyno
            }))[0];
        }
    }

    public searchPersonNames = () => {
        return this.typeahead.lookUpInitiatedByPersonNames({
            searchtext: this.edit!.pers_name || '',
            onlyperson: '1'
        });
    }

    public onPersonNameSelected(event?: InitiatedByPersonNameItem) {
        if (!this.edit) return;

        this.edit.pers_no = !!event ? '' + event.pkey : '0';
        this.edit.pers_name = event?.item_name ?? '';
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(94, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(97, this.edit);

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    custact_member_keyno: string;
    user_name: string;
    responsible: string;
    executer: string;
    contributing: string;
    inform: string;
    advising: string;
    pers_no: string;
    pers_name: string;
    note: string;
    custact_no: string;
    portal_user_keyno: string;
    cust_no: string;
    cust_name: string;
}
